var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activityDuration)?_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"left":"","small":"","dense":""}},[_vm._v("mdi-timer-outline")]),_vm._v("\n    "+_vm._s(_vm.activityDuration)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }